// Logo.jsx
import React from 'react';
import './Logo.css';
import { useTranslation } from 'react-i18next';

const Logo = ({ logoUrl }) => {
  const { t } = useTranslation();

  return (
    <div className="logo-container">
      <img
        src={
          logoUrl ||
          'https://firebasestorage.googleapis.com/v0/b/tabitapp-6b25a.appspot.com/o/TABITA-LOGO.png?alt=media&token=84a93067-34f1-40d2-a5f9-2672f0941a33'
        }
        alt={t('logo.alt')}
        className="app-logo"
      />
    </div>
  );
};

export default Logo;
